import { aliasPaths, pagesByPath } from '../data/pageContent';
import type { PageContent } from '../types/pageContent';

export type ResolvedPage = { kind: 'home' | 'quote' | 'not-found'; path: string } |
  { kind: 'content'; path: string; page: PageContent };

export function resolvePage(pathname: string, search = ''): ResolvedPage {
  let requestedPath = pathname || '/';
  try { requestedPath = decodeURI(requestedPath); } catch { return { kind: 'not-found', path: requestedPath }; }
  const queryPage = new URLSearchParams(search).get('page');
  if (requestedPath === '/' && queryPage) {
    return queryPage === 'request-a-quote' ? { kind: 'quote', path: '/request-a-quote.html' } : { kind: 'not-found', path: requestedPath };
  }
  const path = aliasPaths[requestedPath] || requestedPath;
  if (path === '/' || path === '/index.html') return { kind: 'home', path: '/' };
  if (path === '/request-a-quote.html' || path === '/7.html') return { kind: 'quote', path: '/request-a-quote.html' };
  const page = pagesByPath.get(path);
  return page ? { kind: 'content', path: page.path, page } : { kind: 'not-found', path: requestedPath };
}

export function isCurrentHome(): boolean {
  return resolvePage(window.location.pathname, window.location.search).kind === 'home';
}
